/* eslint-disable import/prefer-default-export */

import { UNAVAILABLE_STATES } from '@airtm/utils/dist/constants/wyreAccounts';
import { PARTNER } from '@airtm/utils/dist/constants/userRoles';
import { isStatusPartial } from 'utils';
import { WithUser_me } from 'graphqlDocuments/queries/__generated__/WithUser';

type WyreState = keyof typeof UNAVAILABLE_STATES;

export const resolvers = {
  Auth__User: {
    canUseCrypto: (root: WithUser_me): boolean => {
      const { country, state, status } = root;

      if (!country || (!isStatusPartial(status) && !state)) return false;

      switch (country) {
        case 'USA':
          return !(state && UNAVAILABLE_STATES[state as WyreState]);

        default:
          return true;
      }
    },
    // This is going to be used for ach Buy, but the name will remain the same to avoid breaking change
    canUseAch: (root: WithUser_me): boolean => {
      const { country, state } = root;

      if (!country || !state) return false;

      switch (country) {
        case 'USA':
          return !(state && UNAVAILABLE_STATES[state as WyreState]);
        default:
          return true;
      }
    },

    canUseAchSell: (root: WithUser_me): boolean => {
      const { country, state } = root;

      if (!country || !state) return false;

      switch (country) {
        case 'USA':
          return !(state && UNAVAILABLE_STATES[state as WyreState]);
        default:
          return true;
      }
    },

    canUseP2P: (root: WithUser_me): boolean => root?.country !== 'USA',

    isPartner: (root: WithUser_me): boolean => !!root?.roles?.includes(PARTNER),
  },
};
